import { useEffect, useState } from "react";
import { useFetch } from "@/hooks/useFetch";
import DataTable from "./DataTable";
import { Pager } from "./kit";

export default function RemoteTable({ url, params, pageSize = 25, reloadKey, testid = "remote-table", onData, ...rest }) {
  const [page, setPage] = useState(1);
  const pkey = JSON.stringify(params || {});
  useEffect(() => setPage(1), [pkey]);
  const { data, loading } = useFetch(url, { ...(params || {}), page, limit: pageSize }, reloadKey);
  useEffect(() => {
    if (data && onData) onData(data);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      <DataTable rows={data?.items || []} loading={loading && !data} pageSize={0} testid={testid} {...rest} />
      <Pager page={page} total={data?.total || 0} limit={pageSize} onPage={setPage} testid={`${testid}-pager`} />
    </div>
  );
}
